// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"65740920","267":"aa42714b","510":"1e570dee","911":"986409fb"}[chunkId] + ".chunk.js";
};